import { useState } from 'react';
import MainLayout from '../../../components/layout/MainLayout';

export default function SystemConfigPage() {
  const [maxCloudPCs, setMaxCloudPCs] = useState('10');
  const [nonHourlyRetentionDays, setNonHourlyRetentionDays] = useState('7');
  const [snapshotLimit, setSnapshotLimit] = useState('5');
  const [hourlyRetentionHours, setHourlyRetentionHours] = useState('24');
  const [overdueStrategy, setOverdueStrategy] = useState<'immediate' | 'delayed'>('immediate');
  const [delayMinutes, setDelayMinutes] = useState('30');

  const [config, setConfig] = useState({
    aliyunAppKey: '',
    aliyunAppSecret: '',
    aliyunSignature: '',
    sendCloudAppKey: '',
    sendCloudAppSecret: '',
    sendCloudSMTP: '',
    autoCloseTicketDays: '7',
    enableAutoAssign: true,
    assignRule: 'round-robin'
  });

  const [showSuccess, setShowSuccess] = useState(false);

  const handleSave = () => {
    // 保存配置逻辑
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  return (
    <MainLayout>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">系统配置</h1>
          <p className="text-sm text-gray-600 mt-1">管理系统全局配置参数</p>
        </div>

        {showSuccess && (
          <div className="mb-5 bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3">
            <i className="ri-checkbox-circle-fill text-green-600 text-xl"></i>
            <span className="text-sm text-green-800">配置保存成功！</span>
          </div>
        )}

        <div className="space-y-6">
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-5 flex items-center gap-2">
              <i className="ri-computer-line text-teal-600"></i>
              云电脑配置
            </h2>
            <div className="space-y-6">
              {/* 1. 单用户最大云电脑数限制 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  单用户最大云电脑数限制
                </label>
                <input
                  type="number"
                  value={maxCloudPCs}
                  onChange={(e) => setMaxCloudPCs(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="请输入最大云电脑数"
                  min="1"
                />
              </div>

              {/* 2. 非按时计费型云电脑到期后保留时长（天） */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  非按时计费型云电脑到期后保留时长（天）
                </label>
                <input
                  type="number"
                  value={nonHourlyRetentionDays}
                  onChange={(e) => setNonHourlyRetentionDays(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="请输入保留天数"
                  min="0"
                />
              </div>

              {/* 3. 快照保留数量限制 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  快照保留数量限制
                </label>
                <input
                  type="number"
                  value={snapshotLimit}
                  onChange={(e) => setSnapshotLimit(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="请输入快照数量限制"
                  min="1"
                />
              </div>

              {/* 4. 按时计费型云电脑到期后保留时长（小时） */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  按时计费型云电脑到期后保留时长（小时）
                </label>
                <input
                  type="number"
                  value={hourlyRetentionHours}
                  onChange={(e) => setHourlyRetentionHours(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                  placeholder="请输入保留小时数"
                  min="0"
                />
              </div>

              {/* 5. 欠费后云电脑处理策略 */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  欠费后云电脑处理策略
                </label>
                <div className="space-y-3">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="radio"
                      name="overdueStrategy"
                      value="immediate"
                      checked={overdueStrategy === 'immediate'}
                      onChange={(e) => setOverdueStrategy(e.target.value as 'immediate')}
                      className="w-4 h-4 text-teal-600 focus:ring-teal-500"
                    />
                    <span className="text-sm text-gray-700">立即停机</span>
                  </label>
                  <label className="flex items-start gap-3 cursor-pointer">
                    <input
                      type="radio"
                      name="overdueStrategy"
                      value="delayed"
                      checked={overdueStrategy === 'delayed'}
                      onChange={(e) => setOverdueStrategy(e.target.value as 'delayed')}
                      className="w-4 h-4 text-teal-600 focus:ring-teal-500 mt-0.5"
                    />
                    <div className="flex-1">
                      <span className="text-sm text-gray-700">延迟停机</span>
                      {overdueStrategy === 'delayed' && (
                        <div className="mt-2 flex items-center gap-2">
                          <span className="text-sm text-gray-600">延迟</span>
                          <input
                            type="number"
                            value={delayMinutes}
                            onChange={(e) => setDelayMinutes(e.target.value)}
                            className="w-24 px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                            placeholder="分钟"
                            min="1"
                          />
                          <span className="text-sm text-gray-600">分钟后停机</span>
                        </div>
                      )}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-5 flex items-center gap-2">
              <i className="ri-message-line text-teal-600"></i>
              短信参数（阿里云短信）
            </h2>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  App Key <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={config.aliyunAppKey}
                  onChange={(e) => setConfig({ ...config, aliyunAppKey: e.target.value })}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  App Secret <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  value={config.aliyunAppSecret}
                  onChange={(e) => setConfig({ ...config, aliyunAppSecret: e.target.value })}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  签名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={config.aliyunSignature}
                  onChange={(e) => setConfig({ ...config, aliyunSignature: e.target.value })}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-5 flex items-center gap-2">
              <i className="ri-mail-line text-teal-600"></i>
              邮件参数（SendCloud）
            </h2>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  App Key <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={config.sendCloudAppKey}
                  onChange={(e) => setConfig({ ...config, sendCloudAppKey: e.target.value })}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  App Secret <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  value={config.sendCloudAppSecret}
                  onChange={(e) => setConfig({ ...config, sendCloudAppSecret: e.target.value })}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  SMTP邮件服务器 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={config.sendCloudSMTP}
                  onChange={(e) => setConfig({ ...config, sendCloudSMTP: e.target.value })}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-5 flex items-center gap-2">
              <i className="ri-customer-service-line text-teal-600"></i>
              工单配置
            </h2>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  工单自动关闭时间（用户无回复X天后）
                </label>
                <input
                  type="number"
                  value={config.autoCloseTicketDays}
                  onChange={(e) =>
                    setConfig({ ...config, autoCloseTicketDays: e.target.value })
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  是否开启自动分配工单
                </label>
                <div className="flex items-center gap-4 mt-2">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      checked={config.enableAutoAssign}
                      onChange={() => setConfig({ ...config, enableAutoAssign: true })}
                      className="w-4 h-4 text-teal-600 cursor-pointer"
                    />
                    <span className="text-sm text-gray-700">开启</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      checked={!config.enableAutoAssign}
                      onChange={() => setConfig({ ...config, enableAutoAssign: false })}
                      className="w-4 h-4 text-teal-600 cursor-pointer"
                    />
                    <span className="text-sm text-gray-700">关闭</span>
                  </label>
                </div>
              </div>
              {config.enableAutoAssign && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    自动分配规则
                  </label>
                  <select
                    value={config.assignRule}
                    onChange={(e) => setConfig({ ...config, assignRule: e.target.value })}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
                  >
                    <option value="round-robin">轮询</option>
                    <option value="load-based">按负载</option>
                    <option value="expertise">按专长</option>
                  </select>
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-3">
            <button className="px-6 py-2.5 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
              取消
            </button>
            <button
              onClick={handleSave}
              className="px-6 py-2.5 bg-teal-600 text-white text-sm rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-save-line mr-2"></i>
              保存配置
            </button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
